import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d804eb02"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "loan-process"
};
const _hoisted_2 = {
  class: "flex-row"
};
const _hoisted_3 = {
  class: "flex-col flex-items-center"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  class: "dash"
}, null, -1));
const _hoisted_5 = {
  class: "flex-col flex-items-center"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  class: "dash"
}, null, -1));
const _hoisted_7 = {
  class: "flex-col flex-items-center"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  class: "dash"
}, null, -1));
const _hoisted_9 = {
  class: "flex-col flex-items-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("h3", null, _toDisplayString($setup.t('loan_process')), 1), _createElementVNode("ul", _hoisted_2, [_createElementVNode("li", _hoisted_3, [_createVNode(_component_svg_icon, {
    class: "icon icon-paper",
    icon: "loan-paper"
  }), _createElementVNode("p", null, _toDisplayString($setup.t('loan_apply')), 1)]), _hoisted_4, _createElementVNode("li", _hoisted_5, [_createVNode(_component_svg_icon, {
    class: "icon icon-warehousing",
    icon: "loan-warehousing"
  }), _createElementVNode("p", null, _toDisplayString($setup.t('loan_received')), 1)]), _hoisted_6, _createElementVNode("li", _hoisted_7, [_createVNode(_component_svg_icon, {
    class: "icon icon-discount",
    icon: "loan-discount"
  }), _createElementVNode("p", null, _toDisplayString($setup.t('loan_repay_interest')), 1)]), _hoisted_8, _createElementVNode("li", _hoisted_9, [_createVNode(_component_svg_icon, {
    class: "icon icon-buy",
    icon: "loan-buy"
  }), _createElementVNode("p", null, _toDisplayString($setup.t('loan_back_assets')), 1)])])]);
}